
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsSelectDateBarItem",
  props: {
    /** 表示する文字列 */
    dateString: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    return {
    };
  }
});
